import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Invite } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<Invite>>>;

const getInvitesForMovement = (id: string): ReturnType => {
    return Request.get(`/workouts/movements/${id}/invites`);
};

export default getInvitesForMovement;
